export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вчера"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сегодня"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Понедельник"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вторник"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Среда"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Четверг"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пятница"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Суббота"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Воскресенье"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["января"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["февраля"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["марта"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["апреля"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["мая"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["июня"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["июля"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["августа"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["сентября"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["октября"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ноября"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["декабря"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Админ"])}
}